






import Vue, { PropType } from "vue";

export interface TextContainsDownloadClipStudioLinkProps {
  replaceKey: string;
  href: string;
  target: string;
  text: string;
  linkText: string;
}

export default Vue.extend({
  name: "vc-text-contains-download-clip-studio-link",
  props: {
    replaceKey: {
      type: String as PropType<
        TextContainsDownloadClipStudioLinkProps["replaceKey"]
      >,
      default: ""
    },
    href: {
      type: String as PropType<TextContainsDownloadClipStudioLinkProps["href"]>,
      default: ""
    },
    target: {
      type: String as PropType<
        TextContainsDownloadClipStudioLinkProps["target"]
      >,
      default: ""
    },
    text: {
      type: String as PropType<TextContainsDownloadClipStudioLinkProps["text"]>,
      default: ""
    },
    linkText: {
      type: String as PropType<
        TextContainsDownloadClipStudioLinkProps["linkText"]
      >,
      default: ""
    }
  },
  computed: {
    computedReplace(): object {
      const userAgent = window.navigator.userAgent.toLowerCase();

      let returnHref = this.href;
      if (this.isIpad(userAgent)) {
        returnHref = this.href + "&isIpad=true";
      }

      return {
        [this.replaceKey]: {
          href: returnHref,
          target: this.target,
          text: this.linkText
        }
      };
    }
  },
  methods: {
    isIpad(userAgent: string) {
      return (
        userAgent.indexOf("ipad") > -1 ||
        (userAgent.indexOf("macintosh") > -1 && "ontouchend" in document)
      );
    }
  }
});
